import BaseApi from '@/core/HttpResources/BaseApi';
import Role from '@/models/security/role.model';
import RoleRequest from '@/models/security/roleRequest.model';
import RoleRequestProcess from '@/models/security/roleRequestProcess.model';

export default class RoleRequestService {
    
    baseApiRol = new BaseApi("RoleRequest");
  
    async generateRequest(request: RoleRequestProcess): Promise<RoleRequestProcess> {
        return new Promise<RoleRequestProcess>((resolve, reject) => this.baseApiRol.request('POST', 'request', request, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async hasAnyRequest(userId:number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => this.baseApiRol.request('GET', "any/" + userId, null, {}, (response) => resolve(response.data), reject, () => { }))
    }

  
}